module.exports = __webpack_public_path__ + "static/media/three.8b2dbf99.svg";